export interface UpdateCollectionMemoRequest {
  // 資料ID
  id: number
  workMemo: string
  displayMemo: string
  localMemo: string
  revision: number
}

export const defaultUpdateCollectionMemoRequest = (): UpdateCollectionMemoRequest => ({
  id: 0,
  workMemo: '',
  displayMemo: '',
  localMemo: '',
  revision: 0
})

export function UpdateCollectionMemoRequestToJSON(
  value: UpdateCollectionMemoRequest
): any {
  return {
    id: value.id,
    work_memo: value.workMemo,
    display_memo: value.displayMemo,
    local_memo: value.localMemo,
    revision: value.revision
  }
}
